import { Divider, Stack } from '@mui/material';
import { MapRef } from 'react-map-gl/mapbox';

import { SquareIconButton } from '@/shared/components/iconButton';
import { Minus, Plus } from '@/shared/components/icons';

const MapNavigationControl = ({ mapRef }: { mapRef: MapRef | null }) => {
  const handleZoomIn = () => {
    if (mapRef) {
      mapRef.getMap().zoomIn();
    }
  };

  const handleZoomOut = () => {
    if (mapRef) {
      mapRef.getMap().zoomOut();
    }
  };

  return (
    <Stack divider={<Divider flexItem sx={{ borderBottomWidth: 2 }} />}>
      <SquareIconButton
        onClick={handleZoomIn}
        aria-label='zoom in'
        size='small'
        color='inherit'
      >
        <Plus fontSize='small' />
      </SquareIconButton>
      <SquareIconButton
        onClick={handleZoomOut}
        aria-label='zoom out'
        size='small'
        color='inherit'
      >
        <Minus fontSize='small' />
      </SquareIconButton>
    </Stack>
  );
};

export default MapNavigationControl;
